import { instance as axios } from "./index";

export default (token = null) => {
  if (token) axios.defaults.headers.common.authorization = `Bearer ${token}`;
  else delete axios.defaults.headers.common.authorization;
};
